import React from "react";
import PrivateRoute from "../components/PrivateRoute";
import { Route, Redirect } from "react-router-dom";
import { pages } from "../constants";
import { PublicTracker } from "../components/OpenFacing/PublicTracker";
import NotFound from "../components/NotFound";
import { NewLoginFormV2OneFormForAllLoginTypes } from "../components/Login/NewLoginFormV2OneFormForAllLoginTypes";
import { Switch } from "react-router-dom";

export const PublicRouteManager = ({
  setLoadingCallback,
  setLastLoginUpdate,
}) => {
  return (
    <Switch>
      <Route path={pages.trackBarcode.url}>
        <PublicTracker />
      </Route>
      <Route
        path={pages.loginPage.url}
        render={() => (
          <NewLoginFormV2OneFormForAllLoginTypes
            setLoading={setLoadingCallback}
            setLastLoginUpdate={setLastLoginUpdate}
          />
        )}
      />
      {/* <Route
            path="/MasterLogin"
            render={() => (
              <MasterLogin
                setLoading={setLoadingCallback}
                setLastLoginUpdate={setLastLoginUpdate}
              />
            )}
          /> */}
      {/* <Redirect
            from="/"
            exact
            to={
              isAuthenticated(undefined, undefined, "/login")
                ? "/order-history"
                : "/login"
            }
          /> */}
      {/* login page will already redirect them to order history if they are authenticated. Gets rid of some redundant toast errors about session being expired*/}
      {/* Might want to rework whole session system at some point, idk */}
      <Redirect from="/" exact to={pages.loginPage.url} />
      {/* if no public page was found, let's just redirect to the login, not sure how we would do a not found page for public routes with this new nested route manager implementation.
       Previously, when all routes were in app.jsx, (when not signed in) going to an actual private route would redirect to the login page, going to a page that doesn't exist would redirect to notfound. 
       Currently, we either redirect them to the login page regardless of route they tried to enter or the not found page for any page that doesn't exist in the publicroutemanager, even if it exists in another route manager */}
      <Redirect to={pages.loginPage.url} />
    </Switch>
  );
};
